import React from "react";
import gsap from "gsap";
import { styles } from "../style";
import { ComputersCanvas } from "./canvas";
import { useAnimations } from "../hooks/useScrollAnimation";

const Hero = () => {
  const { containerRef } = useAnimations(() => {
    gsap.from(".hero-text", {
      y: 100,
      opacity: 0,
      duration: 1.5,
      ease: "power4.out",
      stagger: 0.2,
    });
  });

  return (
    <section ref={containerRef} className="relative w-full h-screen mx-auto">
      <div
        className={`${styles.paddingX} absolute inset-0 top-[120px] max-w-7xl mx-auto flex flex-row items-start gap-5`}
      >
        <div className="flex flex-col justify-center items-center mt-5">
          <div className="w-5 h-5 rounded-full bg-[#915EFF]" />
          <div className="w-1 sm:h-40 h-20 violet-gradient" />
        </div>
        <div className="hero-container">
          <h1 className={`${styles.heroHeadText} text-white hero-text`}>
            Hi, I'm <span className="text-[#915EFF]">Hamza</span>
          </h1>
          <p className={`${styles.heroSubText} text-white-100 hero-text`}>
            5+ years of experience with cloud technologies
            <br className="sm:block hidden" />
          </p>
        </div>
      </div>
      <ComputersCanvas />
      <div className="absolute xs:bottom-10 bottom-32 w-full flex justify-center items-center">
        <a href="#about">
          <div className="w-[35px] h-[64px] rounded-3xl border-4 border-secondary flex justify-center items-start p-2">
            <div
              animate={{
                y: [0, 24, 0],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: "loop",
              }}
              className="w-3 h-3 rounded-full bg-secondary mb-1"
            />
          </div>
        </a>
      </div>
    </section>
  );
};

export default Hero;
